function cov_jbowwc36t() {
  var path = "/app/src/types/lang-locale-type.ts";
  var hash = "24a1ed3fd0e50ce5b982e9f862738f13ae8e81e9";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/types/lang-locale-type.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 30
        },
        end: {
          line: 6,
          column: 10
        }
      },
      "1": {
        start: {
          line: 10,
          column: 20
        },
        end: {
          line: 13,
          column: 10
        }
      },
      "2": {
        start: {
          line: 17,
          column: 22
        },
        end: {
          line: 24,
          column: 10
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "24a1ed3fd0e50ce5b982e9f862738f13ae8e81e9"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_jbowwc36t = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_jbowwc36t();
export var LangDictionary = (cov_jbowwc36t().s[0]++, {
  en: 'en',
  ar: 'ar'
});
export var Lang = (cov_jbowwc36t().s[1]++, {
  en: 'en',
  ar: 'ar'
});
export var Locale = (cov_jbowwc36t().s[2]++, {
  'en-US': 'en-US',
  'ar-AE': 'ar-AE',
  'ar-SA': 'ar-SA',
  'ar-KW': 'ar-KW',
  'ar-BH': 'ar-BH',
  'ar-QA': 'ar-QA'
});